import * as React from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { post } from "@aws-amplify/api";
import { fetchAuthSession } from "@aws-amplify/auth";
import { useTranslation } from "react-i18next";
import { CGI_SUCCESS, congnitoGroups } from "../../helpers/enums";
import { syncOwnerGroupsForUser } from "../../helpers/updateOwnerGroups";
import {
  Box,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@mui/material";

export default function GroupAssignmentModal({
  open,
  setOpen,
  buttonSize,
  userId,
  username,
  fetchData,
  usersGroups,
  allGroups,
  addToGroup,
  setNotificationMessage,
  setOpenNotification,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 5,
    boxShadow: 24,
    p: 1,
  };

  const { t } = useTranslation();
  const [selectedGroups, setSelectedGroups] = React.useState(usersGroups);
  const adminApiName = "AdminQueries";

  React.useEffect(() => {
    setSelectedGroups(usersGroups);
  }, [usersGroups]);

  async function changeUserGroup(userId, newGroups) {
    try {
      const addedGroups = newGroups.filter(
        (item) => !usersGroups.includes(item)
      );
      const removeGroups = usersGroups.filter(
        (item) => !newGroups.includes(item)
      );

      await Promise.all(
        removeGroups.map((group) => removeFromGroup(userId, group))
      );
      await Promise.all(addedGroups.map((group) => addToGroup(userId, group)));
      await syncOwnerGroupsForUser(userId);

      if (removeGroups.length > 0 || addedGroups.length > 0) {
        setNotificationMessage(t("groupAssignmentChanged"));
      } else {
        setNotificationMessage(t("noChanges"));
      }
      await fetchData();
    } catch (e) {
      console.error(e);
      setNotificationMessage(t("errorMessage"));
    }
    setOpenNotification(true);
  }

  async function removeFromGroup(userId, groupname) {
    const path = "/removeUserFromGroup";

    const session = await fetchAuthSession();
    const token = session.tokens?.accessToken?.toString();

    const options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: {
        username: userId,
        groupname: groupname,
      },
    };

    await post({
      apiName: adminApiName,
      path,
      options,
    });
  }

  return (
    <Modal open={open} disableAutoFocus={true}>
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <IconButton
            color="secondary"
            sx={{
              justifySelf: "flex-end",
              width: buttonSize,
              height: buttonSize,
            }}
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", p: 3 }}>
          <Typography>
            {t("newGroupForMail")}
            {` "${username}":`}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              mt: 3,
            }}
          >
            <Select
              value={selectedGroups}
              multiple
              onChange={(event) => setSelectedGroups(event.target.value)}
              sx={{ width: 300 }}
              inputProps={{ "aria-label": "Without label" }}
              size="small"
            >
              {allGroups
                ?.filter((x) => x.GroupName !== congnitoGroups.CONTRIBUTOR)
                .map((group, index) => (
                  <MenuItem key={index} value={group.GroupName}>
                    {group.GroupName}
                  </MenuItem>
                ))}
            </Select>
            <IconButton
              onClick={() => {
                if (selectedGroups) {
                  changeUserGroup(userId, selectedGroups);
                  setOpen(false);
                }
              }}
              disabled={selectedGroups === ""}
              color="secondary"
              sx={{
                color: CGI_SUCCESS,
                width: buttonSize,
                height: buttonSize,
                ml: 1.5,
              }}
            >
              <CheckIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
